import { render, staticRenderFns } from "./AnswerTypeRadioButton.vue?vue&type=template&id=a0bf0882&scoped=true"
import script from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
export * from "./AnswerTypeRadioButton.vue?vue&type=script&lang=js"
import style0 from "./AnswerTypeRadioButton.vue?vue&type=style&index=0&id=a0bf0882&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bf0882",
  null
  
)

export default component.exports